import { useEffect, useRef, useState } from 'react';
import { DialogUI } from '../Interface';
import { useFormikContext } from 'formik';
import { Box, Typography } from '@mui/material';
import { sxConfig } from '../Interface/interface.style';
import { ProjectMain } from './ProjectMain';

const ProjectDialog = ({
  showDialog,
  onClose,
  selectedProjectId = null,
  hideRightPanel = false,
  selectOnClose = true,
  initialAddMode = false,
}) => {
  const { values, setFieldValue, setValues } = useFormikContext();
  const [selectedProject, setSelectedProject] = useState(null);
  const documentValuesRef = useRef(values);
  const documentValuesBeforeOpenRef = useRef(null);

  documentValuesRef.current = values;

  useEffect(() => {
    if (showDialog) {
      documentValuesBeforeOpenRef.current = documentValuesRef.current;
    }
  }, [showDialog]);

  const handleClose = async () => {
    const projectId = selectOnClose ? selectedProject?.projectId ?? null : null;
    const documentValuesBeforeOpen = documentValuesBeforeOpenRef.current;
    const refreshedProjectId =
      selectedProject?.projectId ?? selectedProjectId ?? documentValuesBeforeOpen?.projectId ?? null;
    let valuesToPreserve = {};

    try {
      if (onClose) {
        // ha nincs kiválasztott cikk, null-lal hívjuk vissza
        const changedValues = await onClose(projectId, setFieldValue, refreshedProjectId);
        if (changedValues && typeof changedValues === 'object') {
          valuesToPreserve = changedValues;
        }
      }
    } finally {
      if (selectOnClose && documentValuesBeforeOpen) {
        await setValues(
          projectId
            ? { ...documentValuesBeforeOpen, projectId, ...valuesToPreserve }
            : documentValuesBeforeOpen,
          false
        );
      }

      documentValuesBeforeOpenRef.current = null;
      setSelectedProject(null);
    }
  };

  return (
    <DialogUI
      open={showDialog}
      headerContent={'Projekt'}
      fullWidth={true}
      onClose={handleClose}
      closeBtn={true}
      actionsContent={
        selectedProject?.projectId ? (
          <Box sx={sxConfig.dialogActionContent}>
            <Typography variant="body2" noWrap sx={sxConfig.dialogActionContentTypography1}>
              Választott projekt:
              <Box component="span" sx={sxConfig.dialogActionContentTypography2}>
                {selectedProject?.projectName}
              </Box>
            </Typography>
          </Box>
        ) : null
      }
      maxWidth="xl"
    >
      {showDialog && (
        <ProjectMain
          fromDialog={true}
          dialogSetSelectedProject={setSelectedProject}
          selectedProjectId={selectedProjectId}
          hideRightPanel={hideRightPanel}
          initialAddMode={initialAddMode}
        />
      )}
    </DialogUI>
  );
};

export default ProjectDialog;
